module.exports = __webpack_public_path__ + "static/media/NikeSwoosh.4675bb50.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/NikeSwoosh.svg
// module id = 275
// module chunks = 0